window.$ = window.jQuery = require('../public/vendor/jquery/jquery-2.2.1.min.js')
require('../public/vendor/bootstrap/bootstrap.min.js')
// Librerias
import React from 'react'
import ReactDOM from 'react-dom'

import { Dashboard } from './home/containers/Dashboard.jsx'
// LOGISTICA
import ProgramacionIGMensual from './inventarios/programacion-mensual/ProgramacionIGMensual.jsx'
import { ProgramacionIGSemanal } from './inventarios/programacion-semanal/ProgramacionIGSemanal.jsx'
import ProgramacionAIMensual from './auditorias/programacion-mensual/ProgramacionAIMensual.jsx'
import ProgramacionAISemanal from './auditorias/programacion-semanal/ProgramacionAISemanal.jsx'
import { NominaIG } from './nominas/nominaIG/nominaIG.jsx'
import { DetalleProgramacionIG } from './inventarios/programacion-semanal/Detalle/DetalleProgramacionIG.jsx'
import { DetalleProgramacionAG } from './auditorias/programacion-semanal/Detalle/DetalleProgramacionAG.jsx'
import { ProgramacionPublicada } from './inventarios/ProgramacionPublicada.jsx'
// PROVEEDORES
import { MantenedorHospedajes } from './proveedores/hospedajes/MantenedorHospedajes.jsx'
// TREASURY
import PaymentPartnersIndex from './treasury/payment-partners/PaymentPartnersIndex.jsx';
import { AsignacionFondos } from './contabilidad/asignacion-fondos/AsignacionFondos.jsx'
import { RevisionRendiciones } from './contabilidad/revision-rendiciones/rendiciones/RevisionRendiciones.jsx'
import { DetailsRendicion } from './contabilidad/revision-rendiciones/detalle-rendicion/DetailsRendicion.jsx'
// ANALISIS
import { PanelDatosActa } from './inventarios/archivo-final-fcv/PanelDatosActa.jsx'
import { ConsolidadosDisponibles } from './auditorias/consolidados/ConsolidadosDisponibles.jsx'
import { RevisionArchivoFinal } from './auditorias/revision/RevisionArchivoFinal.jsx'
// ADMIN
import MantenedorLocales2 from './admin/mantenedorLocales2/MantenedorLocales2.jsx'
import { LiderDetalles } from './admin/lider-detalles/LiderDetalles.jsx'
import { StockStores } from './admin/stockStoreUpdate/containers/StockStores.jsx'
import { MantenedorPersonal } from './admin/MantenedorPersonal/MantenedorPersonal.jsx'
import { MantenedorCorreos } from './admin/mantenedorCorreos/mantenedor-correos.jsx'
import { MantenedorCaptadoresZonas } from './admin/mantenedorCaptadoresZonas/captadoresZonas.jsx'
import { MantenedorProducciones } from './admin/mantenedorProducciones/producciones.jsx'
import { MantenedorDistancias } from './admin/distancias/MantenedorDistancias.jsx'
import UsuariosPendientes from './usuariosPendientes/usuariosPendientes.jsx'
import { CalendarMaintainer } from './admin/CalendarMaintainer/CalendarMaintainer.jsx'
// FACTURACION
import { MantenedorDiferencias } from './inventarios/diferencias-inventarios/MantenedorDiferencias.jsx'
import { MantenedorResumenMensual } from './auditorias/resumen-mensual/MantenedorResumenMensual.jsx'
import { InventariosFacturacion } from './inventarios/inventarios-facturacion/InventariosFacturacion.jsx'
import { PeticionOC } from './inventarios/inventarios-facturacion/peticionOC/PeticionOC.jsx'
import { ServiciosRealizados } from './inventarios/inventarios-facturacion/serviciosRealizados/ServiciosRealizados.jsx'
import { MisFacturas } from './facturacion/lista-facturas/cliente-fcv/MisFacturas.jsx'
import { ManagementOC } from './billing/management-oc/ManagementOC.jsx'
import { BillingServices } from './billing/billing-services/BillingServices.jsx'
// OPERACIONES TERRENO
import { ReporteInventario } from './api/reportes/ReporteInventario.jsx'
import { FondosAsignados } from './operarios/fondos-asignados/fondos/FondosAsignados.jsx'
import { DetalleFondo } from './operarios/fondos-asignados/detalle-fondo/DetalleFondo.jsx'
// EMERGENCY COVID
import CollectivePermissionIndex from "./covid/permiso-unico-colectivo/index.jsx";
import reactDom from 'react-dom'
// MODULO OPERADORES
import { RegistroOperador } from './registro-operador/registro.jsx'
import { OperadoresPendientes } from './admin/OperadoresPendientes/OperadoresPendientes.jsx'
// NOTIFICACIONES
import { Global } from './admin/Notificacion/Global.jsx'
import { initFcm } from './notifications/services/fcmService.js'

/** ************************************************************* **/
/** ************************ DASHBOARD ************************** **/
/** ************************************************************* **/

let mainDashboardDOM = document.getElementById('react-main-dashboard')
if (mainDashboardDOM) {
    ReactDOM.render(
        <Dashboard
            perms={window.laravelPerms}
            idClient={window.laravelIdClient}
            dateIndicator={window.laravelDateIndicator}
            stockPending={false}
            //stockPending={window.laravelStockPending}
        />, mainDashboardDOM)
}

let globalNotificationDOM = document.getElementById('global-notification')
if (globalNotificationDOM) {
    ReactDOM.render(
        <Global
        />, globalNotificationDOM)
}

if (window.fcmConfig) {
    initFcm(window.fcmConfig);
}

/** ************************************************************* **/
/** ************************ LOGISTICA ************************** **/
/** ************************************************************* **/

/** PROGRAMACION IG MENSUAL **/
let programacionIGMensualDOM = document.getElementById('react-programacionIG-mensual')
if (programacionIGMensualDOM) {
    let clientes = window.laravelClientes.filter(cliente => cliente.activo);
    ReactDOM.render(
        <ProgramacionIGMensual
            puedeModificar={window.laravelPuedeModificarInventarios}
            puedeAgregar={window.laravelPuedeAgregarInventarios}
            clientes={clientes}
        />, programacionIGMensualDOM)
}

/** PROGRAMACION IG SEMANAL **/
let programacionIGSemanalDOM = document.getElementById('react-programacionIG-semanal')
if (programacionIGSemanalDOM) {
    /** SE FILTRAN CLIENTES EN INVENTARIO SEMANAL **/
    let lideresOtros = window.laravelLideres.filter(lider => lider.id === 990 || lider.id === 466 || lider.id === 10 || lider.id === 286 || lider.id === 33 || lider.id === 35 || lider.id === 62
        || lider.id === 39 || lider.id === 37 || lider.id === 38 || lider.id === 40 || lider.id === 36 || lider.id === 1059 || lider.id === 1061 || lider.id === 66 || lider.id === 54 || lider.id === 41)
    let clientes = window.laravelClientes.filter(cliente => cliente.activo);

    ReactDOM.render(
        <ProgramacionIGSemanal
            puedeModificar={window.laravelPuedeModificarInventarios}
            puedeModificarCaptador={window.laravelPuedeModificarCaptador}
            puedeCambiarLiderSupervisor={window.laravelPuedeCambiarLiderSupervisor}
            puedeModificarDotaciones={window.laravelPuedeModicarDotaciones}
            puedeAprobarCambiosNominas={window.laravelPuedeAprobarCambiosNominas}
            puedeAprobarAumentoDotacion={window.laravelPuedeAprobarAumentoDotacion}
            puedeEditarStock={window.laravelPuedeModificarStock}
            canEditStatusService={window.laravelCanEditStatusService}
            puedeValidarComentarios={window.laravelPuedeValidarComentarios}
            clientes={clientes}
            lideresOtros={lideresOtros}
            lideres={window.laravelLideres}
            supervisores={window.laravelSupervisores}
            captadores={window.laravelCaptadores}
            idUser={window.laravelidUser}
            regiones={window.laravelRegiones}
        />, programacionIGSemanalDOM)
}

/** PROGRAMACIÓN AI MENSUAL */
let programacionAIMensualDOM = document.getElementById('react-programacionAI-mensual')
if (programacionAIMensualDOM) {
    /** IMPORANTE: POR EL MOMENTO SOLO SE MUESTRAN AUDITORIAS DE FCV **/
    ReactDOM.render(
        <ProgramacionAIMensual
            puedeModificar={window.laravelPuedeModificarAuditorias}
            puedeAgregar={window.laravelPuedeAgregarAuditorias}
            clientes={window.laravelClientes}
            auditores={window.laravelAuditores}
        />, programacionAIMensualDOM)
}

/** PROGRAMACION AI SEMANAL **/
let programacionAISemanalDOM = document.getElementById('react-programacionAI-semanal')
if (programacionAISemanalDOM) {
    ReactDOM.render(
        <ProgramacionAISemanal
            puedeModificar={window.laravelPuedeModificarAuditorias}
            puedeRevisar={laravelPuedeRevisarAuditorias}
            puedeRevisarCliente={laravelPuedeRevisarCliente}
            puedeRevisarCantidadMuestras={laravelPuedeRevisarCantidadMuestras}
            puedeVerExcelFacturacion={laravelpuedeVerExcelFacturacion}
            clientes={window.laravelClientes}
            auditores={window.laravelAuditores}
            fcv={window.laravelFcv}
        />, programacionAISemanalDOM)
}

/** PUBLICACION PROGRAMACION IG **/
let programacionPublicada = document.getElementById('react-programacionIG-publicados')
if (programacionPublicada) {
    let clientes = window.laravelClientes.filter(cliente => cliente.nombreCorto === 'FCV' || cliente.nombreCorto === 'FSB' || cliente.nombreCorto === 'PUC' || cliente.nombreCorto === 'CID'
        || cliente.nombreCorto === 'SMU' || cliente.nombreCorto === 'SM' || cliente.nombreCorto === 'MAI' || cliente.nombreCorto === 'SCF'
        || cliente.nombreCorto === 'BLX' || cliente.nombreCorto === 'RDS' || cliente.nombreCorto === 'WAL')
    ReactDOM.render(
        <ProgramacionPublicada
            clientes={clientes}
        />, programacionPublicada)
}

/** NOMINAS **/
let mantenedorNominaIGDOM = document.getElementById('react-nominaIG-nominaIG')
if (mantenedorNominaIGDOM) {
    ReactDOM.render(
        <NominaIG
            nomina={window.laravelNomina}
            comunas={window.laravelComunas}
            permisos={window.laravelPermisos}
            bancos={window.laravelBancos}
            tipoCuentas={window.laravelTipoCuentas}
        />, mantenedorNominaIGDOM)
}

/** DETALLES PROGRAMACION IG **/
let mantenedorDetallesIG = document.getElementById('react-programacionIG-detalles')
if (mantenedorDetallesIG) {
    // let clientes = window.laravelClientes.filter(cliente => cliente.nombreCorto === 'FCV' || cliente.nombreCorto === 'FSB'
    //     || cliente.nombreCorto === 'PUC' || cliente.nombreCorto === 'CID' || cliente.nombreCorto === 'SM' || cliente.nombreCorto === 'MAI'
    //     || cliente.nombreCorto === 'DBS' || cliente.nombreCorto === 'SCF' || cliente.nombreCorto === 'FAX' || cliente.nombreCorto === 'BKA'
    //     || cliente.nombreCorto === 'TM' || cliente.nombreCorto == 'ISA' || cliente.nombreCorto === 'LQX'
    //     || cliente.nombreCorto === 'CLC' || cliente.nombreCorto === 'PAP'
    // );

    ReactDOM.render(
        <DetalleProgramacionIG
            clientes={window.laravelClientes}
            regiones={window.laravelRegiones}
            fechaInicio={window.laravelFechaInicio}
            fechaFin={window.laravelFechaFin}
        />, mantenedorDetallesIG
    )
}

/** ************************************************************* **/
/** ****************** ADMNINISTRACION ************************** **/
/** ************************************************************* **/

/** MANTENEDOR LOCALES **/
let mantenedorLocalesDOM = document.getElementById('react-mantenedor-locales')
if (mantenedorLocalesDOM) {
    ReactDOM.render(
        <MantenedorLocales2
            clientes={window.laravelClientes}
            jornadas={window.laravelJornadas}
            formatoLocales={window.laravelFormatoLocales}
            comunas={window.laravelComunas}
        />, mantenedorLocalesDOM)
}

/** MANTENEDOR STOCK **/
let stockStoresDOM = document.getElementById('react-mantenedor-stock')
if (stockStoresDOM) {
    const clients = window.laravelClientes.filter(cliente => cliente.nombreCorto === 'FCV' || cliente.nombreCorto === 'FSB' || cliente.nombreCorto === 'PUC'
        || cliente.nombreCorto === 'CID' || cliente.nombreCorto === 'SM' || cliente.nombreCorto === 'MAI' || cliente.nombreCorto === 'SCF' || cliente.nombreCorto === 'BLX'
        || cliente.nombreCorto === 'RDS' || cliente.nombreCorto === 'LIQ' || cliente.nombreCorto === 'DBS' || cliente.nombreCorto === 'FAX' || cliente.nombreCorto === 'BKA'
        || cliente.nombreCorto == 'TM' || cliente.nombreCorto == 'ISA' || cliente.nombreCorto === 'LQX'
        || cliente.nombreCorto === 'CLC' || cliente.nombreCorto === 'PAP' || cliente.nombreCorto === 'FAH'
    );

    ReactDOM.render(
        <StockStores
            clients={clients}
            canShowSelect={window.laravelShowSelectClient}
        />, stockStoresDOM
    )
}

/** MANTENEDOR LIDERES **/
let verLiderDetalle = document.getElementById('react-detalles-lider')

if (verLiderDetalle) {
    ReactDOM.render(
        <LiderDetalles
        />,
        verLiderDetalle)
}

/** MANTENEDOR VALORES DISTANCIAS **/
let verMantenedorDistancias = document.getElementById('react-mantenedor-distancias')

if (verMantenedorDistancias) {
    ReactDOM.render(
        <MantenedorDistancias
        />,
        verMantenedorDistancias)
}

/** MANTENEDOR USUARIOS **/
let personalIndexDOM = document.getElementById('react-personal-index')
if (personalIndexDOM) {
    ReactDOM.render(
        <MantenedorPersonal
            clientes={window.laravelClientes}
            perms={window.laravelPerms}
            documentationStatus={window.laravelDocumentationStatus}
        />,
        personalIndexDOM
    )
}

let correosDOM = document.getElementById('react-mantenedor-clientes')
if (correosDOM) {
    ReactDOM.render(
        <MantenedorCorreos
            clientes={window.laravelClientes}
        />,
        correosDOM
    )
}

/** MANTENEDOR PRODUCCIONES **/
let mantenedorProducciones = document.getElementById('react-producciones')

if (mantenedorProducciones) {
    let clientes = window.laravelClientes.filter(cliente => cliente.nombreCorto === 'FCV' || cliente.nombreCorto === 'PUC' || cliente.nombreCorto === 'FSB' || cliente.nombreCorto === 'MAI' || cliente.nombreCorto === 'CID')
    ReactDOM.render(
        <MantenedorProducciones
            clientes={clientes}
        />,
        mantenedorProducciones)
}

/** USUARIOS PENDIENTES DESDE INVENTARIOS **/
let mantenedorUsuariosPendientes = document.getElementById('react-usuariosPendientes')
if (mantenedorUsuariosPendientes) {
    ReactDOM.render(
        <UsuariosPendientes
            clientes={window.laravelClientes}
        />, mantenedorUsuariosPendientes)
}

/** MANTENEDOR CAPTADORES POR ZONA **/
let mantenedorCaptadoresZonas = document.getElementById('react-captadoresZonas')
if (mantenedorCaptadoresZonas) {
    ReactDOM.render(
        <MantenedorCaptadoresZonas
            captadores={window.laravelCaptadores}
            comunas={window.laravelComunas}
        />,
        mantenedorCaptadoresZonas)
}

/** CALENDAR MANTAINER **/
let calendarMaintainer = document.getElementById('react-calendar-maintainer')
if (calendarMaintainer) {
    ReactDOM.render(
        <CalendarMaintainer
            months={window.laravelMonths}
        />,
        calendarMaintainer
    )
}
/** ************************************************************* **/
/** ******************** FACTURACION **************************** **/
/** ************************************************************* **/

/** REVISIÓN UNIDADES A FACTURAR **/
let mantenedorDiferencias = document.getElementById('react-inventarios-diferencias')
if (mantenedorDiferencias) {
    ReactDOM.render(
        <MantenedorDiferencias
            meses={window.laravelMeses}
            permisos={window.laravelPermisos}
        />,
        mantenedorDiferencias)
}

/** REVISION AUDITORIAS A FACTURAR **/
let mantenedorResumenMensual = document.getElementById('react-resumen-auditorias')

if (mantenedorResumenMensual) {
    ReactDOM.render(
        <MantenedorResumenMensual
            meses={window.laravelMeses}
            permisos={window.laravelPermisos}
        />,
        mantenedorResumenMensual)
}

/** REVISION INVENTARIOS A FACTURAR (OTROS CLIENTES) **/
let mantenedorInventariosFacturacion = document.getElementById('react-aprobacion-facturacion')

if (mantenedorInventariosFacturacion) {
    ReactDOM.render(
        <InventariosFacturacion
            meses={window.laravelMeses}
            clientes={window.laravelClientes}
            permisos={window.laravelPermisos}
        />,
        mantenedorInventariosFacturacion)
}

/** MANTENEDOR GENERACION ORDEN DE COMPRA (PUC - SB) **/
let mantenedorPeticionOC = document.getElementById('react-peticion-oc')

if (mantenedorPeticionOC) {
    ReactDOM.render(
        <PeticionOC
            inventarios={window.laravelInventarios}
            cliente={window.laravelCliente}
            sumaUnidades={window.laravelSumaUnidades}
            valorBruto={window.laravelValorBruto}
            valorNeto={window.laravelValorNeto}
            fechaInicial={window.laravelFechaInicial}
            fechaFinal={window.laravelFechaFinal}
        //permisos = {window.laravelPermisos}
        />,
        mantenedorPeticionOC)
}

/** MANTENEDOR SERVICIOS REALIZADOS (PUC - SB) **/
let mantenedorServiciosRealizados = document.getElementById('react-servicios-realizados')

if (mantenedorServiciosRealizados) {
    ReactDOM.render(
        <ServiciosRealizados
            meses={window.laravelMeses}
            //clientes = {window.laravelClientes}
            permisos={window.laravelPermisos}
            cliente={window.laravelCliente}
        />,
        mantenedorServiciosRealizados)
}

/** MANTENEDOR LISTADO DE FACTURAS **/
let mantenedorFacturasFCV = document.getElementById('react-facturas-fcv')

if (mantenedorFacturasFCV) {
    ReactDOM.render(
        <MisFacturas
            cliente={window.laravelCliente}
        />,
        mantenedorFacturasFCV)
}
/** MANAGEMENT OC **/
let managementOC = document.getElementById('react-management-oc')
if (managementOC) {
    ReactDOM.render(
        <ManagementOC
            idBillingRequest={window.laravelIdBillingRequest}
            idClient={window.laravelIdClient}
            perms={window.laravelPerms}
        />,
        managementOC
    )
}
/** BILLING SERVICES LIST FSB GROUP **/
let billingServices = document.getElementById('react-billing-services')
if (billingServices) {
    ReactDOM.render(
        <BillingServices
            monthsDate={window.laravelMonths}
        />,
        billingServices
    )
}
/** ************************************************************* **/
/** ******************** ANALISIS ******************************* **/
/** ************************************************************* **/

/** MANTENEDOR RESULTADO INVENTARIO **/
let datosActaInventarioDOM = document.getElementById('react-datos-acta-inventario-fcv')
if (datosActaInventarioDOM) {
    ReactDOM.render(
        <PanelDatosActa
            idInventario={window.laravelIdInventario}
            puedeEditar={window.laravelpuedeEditar}
        />, datosActaInventarioDOM)
}
/** MANTENEDOR CONSOLIDADOS IRD VENCIMIENTO **/
let mantenedorConsolidadosAud = document.getElementById('react-consolidados-auditorias')

if (mantenedorConsolidadosAud) {
    ReactDOM.render(
        <ConsolidadosDisponibles
            meses={window.laravelMeses}
            tipos={window.laravelTipos}
        />,
        mantenedorConsolidadosAud)
}

/** MANTENEDOR REVISION AUDITORIAS **/
let verRevisionArchivoFinal = document.getElementById('react-revision-archivo-final')

if (verRevisionArchivoFinal) {
    ReactDOM.render(
        <RevisionArchivoFinal
            idAuditoria={window.laravelAuditoria}
            fcv={window.laravelFcv}
        />,
        verRevisionArchivoFinal)
}

/** DETALLES PROGRAMACION AG **/
let mantenedorDetallesAG = document.getElementById('react-programacionAG-detalles')
if (mantenedorDetallesAG) {
    let clientes = window.laravelClientes.filter(cliente => cliente.nombreCorto === 'FCV' || cliente.nombreCorto === 'FSB'
        || cliente.nombreCorto === 'PUC' || cliente.nombreCorto === 'CID' || cliente.nombreCorto === 'SM' || cliente.nombreCorto === 'MAI'
        || cliente.nombreCorto === 'DBS' || cliente.nombreCorto === 'SCF' || cliente.nombreCorto === 'FAX' || cliente.nombreCorto === 'BKA'
        || cliente.nombreCorto === 'TM' || cliente.nombreCorto == 'ISA' || cliente.nombreCorto === 'LQX'
        || cliente.nombreCorto === 'CLC' || cliente.nombreCorto === 'PAP'
    );

    ReactDOM.render(
        <DetalleProgramacionAG
            clientes={clientes}
            regiones={window.laravelRegiones}
            fechaInicio={window.laravelFechaInicio}
            fechaFin={window.laravelFechaFin}
        />, mantenedorDetallesAG
    )
}
/** ************************************************************* **/
/** ****************** OPERACIONES TERRENO ********************** **/
/** ************************************************************* **/

/** REPORTES DESARROLLO INVENTARIOS **/
let verReporteInventario = document.getElementById('react-reporte-inventario')

if (verReporteInventario) {
    ReactDOM.render(
        <ReporteInventario
            idInventario={window.laravelIdInventario}
            nomina={window.laravelNomina}
        />,
        verReporteInventario)
}
/** MIS FONDOS OPERARIO **/
let verFondosAsignados = document.getElementById('react-fondos-asignados')

if (verFondosAsignados) {
    ReactDOM.render(
        <FondosAsignados
        />,
        verFondosAsignados)
}

/** Detalle Fondo **/
let verDetalleFondo = document.getElementById('react-detalle-fondo')

if (verDetalleFondo) {
    ReactDOM.render(
        <DetalleFondo
            idRendicion={window.idRendicion}
            idLider={window.idLider}
            fechaInicial={window.fechaInicial}
            fechaFinal={window.fechaFinal}
        />,
        verDetalleFondo)
}
/** ************************************************************* **/
/** ********************* CONTABILIDAD ************************** **/
/** ************************************************************* **/

/** PAYMENT PARTNERS **/
let paymentPartners = document.getElementById('react-payment-partners');
if (paymentPartners) {
    ReactDOM.render(
        <PaymentPartnersIndex
            recruiters={window.laravelRecruiters}
            clients={window.laravelClients}
        />,
        paymentPartners)
}

/** MANTENEDOR ASIGNACION DE FONDOS SUPERVISORES **/
let verFondos = document.getElementById('react-fondos-rendiciones')

if (verFondos) {
    ReactDOM.render(
        <AsignacionFondos
        />,
        verFondos)
}
/** REVISAR RENDICIONES **/
let verRevisionRendiciones = document.getElementById('react-revision-rendiciones');
if (verRevisionRendiciones) {
    ReactDOM.render(
        <RevisionRendiciones
        />,
        verRevisionRendiciones
    )
}

/** DETALLE RENDICION **/
let verDetalleRendicion = document.getElementById('react-revision-detalle');
if (verDetalleRendicion) {
    ReactDOM.render(
        <DetailsRendicion
            rendicion={window.laravelRendicion}
            gastos={window.laravelGastos}
        />,
        verDetalleRendicion
    )
}
/** ************************************************************* **/
/** ********************* PROVEEDORES *************************** **/
/** ************************************************************* **/

/** MANTENEDOR HOSPEDAJES **/
let verMantenedorHospedajes = document.getElementById('react-mantenedor-hospedajes');

if (verMantenedorHospedajes) {
    ReactDOM.render(
        <MantenedorHospedajes
        />,
        verMantenedorHospedajes)
}
/** ***************************************************************** **/
/** ********************* EMERGENCY COVID *************************** **/
/** ***************************************************************** **/
let showCollectivePermission = document.getElementById('react-covid-collective-permission');
if (showCollectivePermission) {
    ReactDOM.render(
        <CollectivePermissionIndex />, showCollectivePermission
    )
}

/** MODULO DE OPERADORES **/
//REGISTRO
let verRegistroOperador = document.getElementById('react-registro-operador');

if (verRegistroOperador) {
    reactDom.render(
        <RegistroOperador
            usuario={window.laravelUsuario}
            rm={window.laravelRM} />, verRegistroOperador
    )
}

/** MODULO DE ADMINISTRACION DE REGISTRADORES PENDIENTES **/
//CONFIRMAR REGISTRO

let verOperadoresPendientes = document.getElementById('react-operadores-pendientes');

if (verOperadoresPendientes) {
    reactDom.render(
        <OperadoresPendientes 
            captadores={window.laravelCaptadores}
            operadores={window.laravelOperadores} />, verOperadoresPendientes
    )
}


// WEBPACK FOOTER //
// ./frontEnd/boot-client.jsx